import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import type { FiltersUiVersion } from '@zaoblako/web/core/types/filters-ui-version.type';
import type { ProjectFindInterface } from '@zaoblako/shared/modules/project/dto/project/project-find.dto';
import { StatusLabelComponent } from '@zaoblako/web/shared/components/status-label/status-label.component';
import { MultiSelectComponent } from '@zaoblako/web/shared/dumbs/dropdowns/multi-select/multi-select.component';
import { SingleSelectComponent } from '@zaoblako/web/shared/dumbs/dropdowns/single-select/single-select.component';
import { HighlightMatchTextHelper } from '@zaoblako/web/shared/helpers/highlight-match-text.helper';
import { SafeHtmlPipe } from '@zaoblako/web/shared/pipes/safe-html.pipe';

@Component({
  selector: 'crm-project-multi-select',
  standalone: true,
  imports: [CommonModule, MultiSelectComponent, StatusLabelComponent, SafeHtmlPipe],
  templateUrl: './project-multi-select.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProjectMultiSelectComponent {
  @Input() public filtersUiVersion: FiltersUiVersion = 'v2';

  @ViewChild('singleSelectComponent', { static: true }) public singleSelectComponent: SingleSelectComponent;

  @Input() public projects: ProjectFindInterface[] = [];
  @Input() public selectedProjects: ProjectFindInterface[] = [];
  @Input() public isError = false;
  @Input() public class: string;
  @Input() public styleClass: string;
  @Input() public disabled: boolean;
  @Input() public appendTo: string;

  @Output() public selectedProjectsChange = new EventEmitter<ProjectFindInterface[]>();

  public toProject(project: any): ProjectFindInterface {
    return project as ProjectFindInterface;
  }

  public highlightMatchText(text: string): string {
    return HighlightMatchTextHelper.highlightMatchText(text, this.singleSelectComponent?.dropdown?.filterValue);
  }
}
